import { createContext } from 'react';

export const PKCEContext = createContext({
  logout: () => {}
});
